"use client"

import Logo from "./Logo"
import dynamic from "next/dynamic"
import DisabledSearchBar from "./DisabledSearchBar"
import DisabledLinks from "./DisabledLinks"
import type { SearchEntry } from "@/lib/content/types"

const SearchBar = dynamic(() => import("./SearchBar"), {
  ssr: false,
  loading: () => <DisabledSearchBar />,
})
const Links = dynamic(() => import("./Links"), {
  ssr: false,
  loading: () => <DisabledLinks />,
})

const Header = ({ searchIndex }: { searchIndex: SearchEntry[] }) => {
  return (
    <header className="fixed z-50 w-full py-3 px-3 sm:px-4 lg:px-10 flex items-center justify-between">
      <Logo />
      <Links />
      <SearchBar searchIndex={searchIndex} />
    </header>
  )
}

export default Header
